export const pagesQaOperationsCoreEn = {
  sidebar: {
    defectInventory: 'Defect Inventory',
    enhanceReportInventory: 'Enhancement Report Inventory',
    testAssetInventory: 'Test Asset Inventory',
    testAssetRegistration: 'Test Asset Registration',
    testPlan: 'Test Plan',
    testReview: 'Test Review',
    underDevelopment: 'This operation package is currently under development.'
  },
  testPlan: {
    anchorDate: {
      missingTarget: 'No target production selected',
      missingTargetDescription: 'Go back and select a target production to create a test plan for.',
      pageTitle: 'Set the Reference Date',
      start: 'Start',
      startFailed: 'Failed to start test plan creation',
      startSuccess: 'Test plan creation started'
    },
    instance: {
      approveAll: 'Approve all',
      approveAllSuccess: 'Approved all successfully',
      assignee: 'Assignee',
      backToCore: 'QA Operations Core',
      cannotApproveAll: 'Cannot approve all because there are no waiting approval tasks',
      progressTitle: 'Progress',
      requestedFor: 'Requested For'
    },
    list: {
      packageEmptyState: {
        description: 'The test plan creation operation package is not available yet.',
        title: 'No operation package found'
      },
      patternEmptyState: {
        description: 'Add a pattern to start test plan creation operations.',
        title: 'No patterns yet'
      },
      startNew: 'New Test Plan',
      taskEmptyState: {
        description: 'Create a new test plan and it will be listed here.',
        title: 'No test plans yet'
      }
    },
    targetSelection: {
      anchorDateLabel: 'Reference Date',
      missingPackageInfo: 'Operation package information is missing',
      missingPackageInfoDescription: 'Go back to the QA Operations Core and start again.',
      pageTitle: 'Select a Target Production',
      searchPlaceholder: 'Search by production or product name'
    }
  }
};